import * as types from '../actions/actionTypes';

const defaultState = {
  status: 'init', // Page Loading Status
  // code: 200,
  metaSttShow: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_PAGE_STATUS:
      return { ...state, status: action.data };
    case types.UPDATE_MESSAGE_STATUS:
      return { ...state, metaSttShow: action.data };

    case types.UPLOAD_IMAGE:
      return { ...state, updatingImagePicture: true };
    case types.UPLOAD_IMAGE_SUCCESS:
      return { ...state, updatingImagePicture: false };
    case types.UPLOAD_IMAGE_FAILED:
      return { ...state, updatingImagePicture: false };
    default:
      return state;
  }
};
